function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: eprivacy
 * Version: 7.3.0-ALPHA-3
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import React from 'react';
import { render } from 'react-dom';
import ConsentManager from './consent-manager';
import translations from './translations';
import Main from './components/main';
import { convertToMap, update } from './utils/maps';
import { t, language } from './utils/i18n';
import { createCssNamespace } from './utils/css';
import ContextualConsentNotice from './components/contextual-consent-notice';
import { render as reactRender } from 'react-dom';
function getElement(config) {
  var id = config.elementID,
    stylePrefix = config.stylePrefix;
  var element = document.getElementById(id);
  if (element === null) {
    element = document.createElement('div');
    element.id = id;
    document.body.insertBefore(element, document.body.firstChild);
  }
  var child = document.querySelector(".".concat(stylePrefix, "-AppContainer"));
  if (child === null) {
    child = document.createElement('div');
    child.className = "".concat(stylePrefix, "-AppContainer");
    element.appendChild(child);
  }
  return document.querySelector(".".concat(stylePrefix, "-AppContainer"));
}
function getTranslations(config) {
  var trans = new Map([]);
  update(trans, convertToMap(translations));
  update(trans, convertToMap(config.translations));
  return trans;
}
var managers = {};
function getManager(config) {
  var name = config.elementID;
  if (managers[name] === undefined) {
    managers[name] = new ConsentManager(config);
  }
  return managers[name];
}
export var defaultConfig = {
  elementID: 'orejime',
  appElement: undefined,
  stylePrefix: 'orejime',
  cookieName: 'orejime',
  cookieExpiresAfterDays: 365,
  cookieDomain: undefined,
  stringifyCookie: JSON.stringify.bind(JSON),
  parseCookie: JSON.parse.bind(JSON),
  privacyPolicy: '',
  default: true,
  mustConsent: false,
  mustNotice: false,
  logo: false,
  lang: language(),
  translations: {},
  apps: {},
  debug: false,
  declineLink: false
};
export function init(conf) {
  var config = Object.assign({}, defaultConfig, conf);
  var errors = [];
  if (!Object.keys(config.apps).length) {
    errors.push('  - you must define `apps` to manage');
  }
  if (!config.privacyPolicy.length) {
    errors.push('  - you must define a `privacyPolicy` url');
  }
  if (errors.length) {
    errors.unshift('Orejime config error:');
    console.error(errors.join('\n'));
    return;
  }
  var element = getElement(config);
  var trans = getTranslations(config);
  var manager = getManager(config);
  var tt = function tt() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return t.apply(void 0, [trans, config.lang, config.debug].concat(args));
  };
  var app = render(/*#__PURE__*/React.createElement(Main, {
    t: tt,
    ns: createCssNamespace(config.stylePrefix),
    manager: manager,
    config: config
  }), element);
  renderContextualConsentNotices(manager, tt, config.lang, config);
  return {
    show: app.showModal.bind(app),
    internals: {
      react: app,
      manager: manager,
      config: config
    }
  };
}
function renderContextualConsentNotices(manager, tt, lang, config) {
  var notices = [];
  var _iterator = _createForOfIteratorHelper(config.apps),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var service = _step.value;
      var consent = manager.getConsent(service.name) && manager.confirmed;
      var elements = document.querySelectorAll("[data-name='" + service.name + "']");
      var _iterator2 = _createForOfIteratorHelper(elements),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var element = _step2.value;
          var ds = dataset(element);
          if (ds.type === 'placeholder') {
            continue;
          }
          if (element.tagName === 'IFRAME' || element.tagName === 'DIV') {
            var placeholderElement = element.previousElementSibling;
            if (placeholderElement !== null) {
              var _ds = dataset(placeholderElement);
              if (_ds.type !== "placeholder" || _ds.name !== service.name) {
                placeholderElement = null;
              }
            }
            if (placeholderElement === null) {
              placeholderElement = document.createElement("DIV");
              placeholderElement.style.maxWidth = element.width + "px";
              placeholderElement.style.height = element.height + "px";
              placeholderElement.classList.add("orejime-content__context-notice");
              placeholderElement.classList.add("orejime-content__context-notice--" + service.name);
              applyDataset({
                type: 'placeholder',
                name: service.name
              }, placeholderElement);
              // if consent is already given, we still insert an invisble placeholder that
              // might be revealed later if the user changes the consent decision
              if (consent) {
                placeholderElement.style.display = 'none';
              }
              element.parentElement.insertBefore(placeholderElement, element);
              var notice = reactRender(/*#__PURE__*/React.createElement(ContextualConsentNotice, {
                t: tt,
                lang: lang,
                manager: manager,
                config: config,
                service: service,
                style: ds.style,
                api: ds.style
              }), placeholderElement);
              notices.push(notice);
            }
            if (element.tagName === 'IFRAME') {
              ds['src'] = element.src;
            }
            if (ds['modified-by-orejime'] === undefined && element.style.display === undefined) {
              ds['original-display'] = element.style.display;
            }
            ds['modified-by-orejime'] = 'yes';
            applyDataset(ds, element);
            if (!consent) {
              element.removeAttribute('src');
              element.style.display = 'none';
            }
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      if (!!service.transform) {
        service.transform(elements, consent);
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return notices;
}
function dataset(element) {
  var dataset = {};
  for (var i = 0; i < element.attributes.length; i++) {
    var attribute = element.attributes[i];
    if (attribute.name.startsWith('data-')) {
      dataset[attribute.name.slice(5)] = attribute.value;
    }
  }
  return dataset;
}
function applyDataset(ds, element) {
  var keys = Object.keys(ds);
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var value = ds[key];
    if (element[key] !== value) {
      element.setAttribute('data-' + key, value);
    }
  }
}
export default {
  init: init,
  defaultConfig: defaultConfig
};